"use client";

import React from "react";
import {useUser} from "@/lib/useUser";
import {Button} from "@/components/ui/button";
import heroImg from "@/public/images/WebsiteImages/Hero.png";
import { useRouter, useSearchParams } from 'next/navigation'
import Image from 'next/image';
import { useDemoModal } from "@/hooks/useDemoModal";

export const HeroSection: React.FC = () => {
    const router = useRouter();
    const [user] = useUser();
    const { openModal, DemoModal } = useDemoModal();

    const handleDemo = () => {
        openModal();
    }
    return (
        <section className="bg-[#ebf2f0] py-8 px-4 sm:px-6 lg:px-8 mt-10">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-12">
                    <div className="lg:w-[45%]">
                        <h1 className="text-2xl sm:text-3xl lg:text-4xl   font-bold text-gray-900 mb-4 leading-tight">
                        Smart Agri Operating System
                        </h1>
                        <p className="text-base sm:text-lg text-gray-600 mb-8 leading-relaxed">
                            The unified platform agri-input brands use to monitor field officers, engage farmers, and convert season activity into measurable sales
                        </p>
                        <div className="grid grid-cols-3 gap-6 mb-8">
                            <div className="text-center">
                                <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">30 M</p>
                                <p className="text-l text-gray-600">Field Activities Tracked</p>
                            </div>
                            <div className="text-center">
                                <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">600 K</p>
                                <p className="text-l text-gray-600">Villages Covered</p>
                            </div>
                            <div className="text-center">
                                <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">2 M</p>
                                <p className="text-l text-gray-600">Farmers Managed</p>
                            </div>
                        </div>
                        <Button className="bg-primary hover:bg-secondary text-white rounded-sm transition duration-300 ease-in-out transform hover:scale-105 font-bold" onClick={handleDemo}>
                            Book a Demo
                        </Button>
                    </div>

                    <div className="lg:w-[55%] flex justify-end">
                        <div className="relative w-full">
                            <Image
                                className="w-full h-auto min-h-[400px] max-h-[500px] object-contain object-center ml-8"
                                src={heroImg}
                                alt="Farmers and business professionals"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <DemoModal />
        </section>
    )
}
